import { getConfigArrayString } from "../util/config";

// Actions
export const LANGUAGE_CHANGE: string = "Localisation/LANGUAGE_CHANGE";

// Countries
export const COUNTRY_INDEX_REQUEST: string = "Localisation/Countries/INDEX_REQUEST";
export const COUNTRY_INDEX_SUCCESS: string = "Localisation/Countries/INDEX_SUCCESS";
export const COUNTRY_INDEX_FAILURE: string = "Localisation/Countries/INDEX_FAILURE";

export const PRIORITY_COUNTRIES: string[] = getConfigArrayString("PRIORITY_COUNTRIES");
